export default __webpack_public_path__ + "static/media/pos-pro-23.f272cae1.jpg";